export default "__VITE_ASSET__DqL9kG4d__"